// Mock data for HERTZ product website (Bluu Sky Private Limited)

export const BRAND = {
  name: "Bluu Sky",
  suffix: "PRIVATE LIMITED",
  product: "HERTZX",
  tagline: "INTEGRATED HANDS-FREE COMMUNICATION SYSTEM",
  subtagline: "FULL DUPLEX | HANDS-FREE | MISSION READY",
};

export const CONTACT = {
  address: "Building No. / Plot No. 58 G, Khanda Colony, Sector-5, New Panvel, Raigad, Maharashtra — 410206, India",
  email: "bluuskyltd@gmail.com",
  website: "www.bluuskyltd.in",
};

export const NAV_LINKS = [
  { href: '#home', label: 'Home' },
  { href: '#modules', label: 'Product' },
  { href: '#overview', label: 'Overview' },
  { href: '#compare', label: 'Why Choose Us' },
  { href: '#contact', label: 'Contact' },
];

// Top strip 7 industry tiles — matches the IDEAL FOR section images exactly
export const TOP_STRIP = [
  { label: 'FIRE\nFIGHTING',           img: '/fire_safety.jpeg' },
  { label: 'DEFENCE',                   img: '/defense.jpeg' },
  { label: 'NAVY &\nCOAST GUARD',       img: '/navy.jpeg' },
  { label: 'INDUSTRIAL\nSAFETY',        img: '/industrial_safety.jpeg' },
  { label: 'MINING\nOPERATIONS',        img: '/oil.jpeg' },
  { label: 'CORPORATE\nSECURITY',       img: '/corporate.jpeg' },
  { label: 'DISASTER\nRESPONSE',        img: '/disaster.jpeg' },
];

export const LOGO_IMG = '/logo_white.png';
export const RANGE_EXT_IMG = 'https://customer-assets-gfyr7b9c.emergentagent.net/job_pdf-to-web-build/artifacts/i8jnm1ao_bg_range_extension.png';

// Scene tiles for How It Works diorama
export const RANGE_SCENES = [
  { key: 'building',  label: '1 TO 1 (LOS)',                     sub: 'UP TO 1 – 2 KM*',       from: 'left',   img: 'https://images.unsplash.com/photo-1635751753205-e443f0bc4b02?w=800&q=85' },
  { key: 'factory',   label: 'WITH 1 BOOSTER (LOS)',             sub: 'UP TO 1 – 2 KM*',       from: 'top',    img: 'https://images.unsplash.com/photo-1566221857770-508d35ee6220?w=800&q=85' },
  { key: 'tunnel',    label: 'ENCLOSED SPACES',                  sub: 'STABLE COMMS',          from: 'right',  img: 'https://images.unsplash.com/photo-1655584439090-bcbaf3f12732?w=800&q=85' },
  { key: 'fire',      label: 'GROUND OPERATIONS',                sub: 'REAL-TIME',             from: 'left',   img: 'https://images.unsplash.com/photo-1531431199010-1f9985f83baa?w=800&q=85' },
  { key: 'ship',      label: 'WITH MULTIPLE BOOSTERS (RELAY)',   sub: 'GREATER COVERAGE',      from: 'right',  img: 'https://images.unsplash.com/photo-1719553946838-1190abdeee92?w=800&q=85' },
];

export const HERO_PRODUCT_IMG = '/mod_commander.png';
export const BOOSTER_PRODUCT_IMG = '/mod_booster.png';
export const HELMET_PRODUCT_IMG = '/mod_helmet.png';

// Ordered set of 3 module cards for hero showcase
export const HERO_MODULES = [
  { key: 'commander', title: 'COMMANDER', sub: 'Hand Held', img: '/mod_commander.png' },
  { key: 'booster', title: 'PORTABLE BOOSTER', sub: 'Pocket Carry', img: '/mod_booster.png' },
  { key: 'helmet', title: 'HELMET MOUNTABLE', sub: 'Helmet & Uniform', img: '/mod_helmet.png' },
];

export const HERO_INTRO = "Mission-critical communication that keeps your team connected, coordinated and safe — anytime, anywhere.";

export const HERO_FEATURES = [
  { icon: "AudioLines", title: "FULL DUPLEX COMMUNICATION", desc: "Simultaneous talk & listen for natural conversations." },
  { icon: "Hand", title: "HANDS-FREE OPERATION", desc: "Voice activated, 100% hands free for complete focus." },
  { icon: "Feather", title: "ULTRA LIGHTWEIGHT", desc: "All models < 120 grams (including battery)." },
  { icon: "Radio", title: "PORTABLE BOOSTER COMPATIBLE", desc: "Extends range by up to 1–2 KM (LOS) to the existing network." },
  { icon: "ShieldCheck", title: "RUGGED & RELIABLE", desc: "IP65+ protection, built for extreme environments." },
  { icon: "Timer", title: "RAPID DEPLOYMENT", desc: "Pocket sized, mission ready in seconds." },
];

export const IDEAL_FOR = [
  { icon: "Flame", label: "Fire Fighting" },
  { icon: "ShieldHalf", label: "Defence & Tactical Operations" },
  { icon: "Anchor", label: "Navy & Coast Guard" },
  { icon: "Factory", label: "Industrial Safety" },
  { icon: "Pickaxe", label: "Mining Operations" },
  { icon: "Building2", label: "Corporate Security" },
  { icon: "TriangleAlert", label: "Disaster Response" },
];

export const HERO_STRIP = [
  { icon: "ShieldCheck", title: "IP65+", sub: "PROTECTION" },
  { icon: "Radio", title: "UP TO 1–2 KM", sub: "ADDITIONAL RANGE WITH BOOSTER (LOS)" },
  { icon: "Timer", title: "SECONDS", sub: "TO DEPLOY" },
  { icon: "Usb", title: "TYPE-C", sub: "FAST CHARGING" },
  { icon: "Feather", title: "ALL MODELS", sub: "< 120 GRAMS" },
];

export const MODELS_TEASER = [
  { title: "COMMANDER MODEL", sub: "Hand Held" },
  { title: "PORTABLE BOOSTER", sub: "Pocket Carry" },
  { title: "HELMET MOUNTABLE MODEL", sub: "Helmet & Uniform Mountable" },
];

// ---- Overview ----
export const PRODUCT_SUMMARY = [
  { attribute: "Product Name", details: "HERTZX™ Integrated Hands-Free Communication System" },
  { attribute: "Feature", details: "Full Duplex – Hands-Free – Mission Ready" },
  { attribute: "Models", details: "Commander Module, Portable Booster, Helmet Unit (K-Type)" },
  { attribute: "Form Factors", details: "Handheld / Portable Booster / Helmet Mountable / Uniform Mountable" },
];

export const DETAILED_SPECS = [
  { feature: "Communication Mode", description: "Full Duplex (Simultaneous Talk & Listen)" },
  { feature: "Operation", description: "Hands-Free, Voice Activated" },
  { feature: "Weight", description: "All Models < 120 g (including battery)" },
  { feature: "Mounting", description: "Helmet & Uniform Mountable" },
  { feature: "Hands Availability", description: "100% Hands Free" },
  { feature: "Booster Support", description: "Yes, Portable Handheld Booster Compatible" },
  { feature: "Range (Without Booster)", description: "Comparable or superior UHF line-of-sight performance depending on antenna, terrain and operating conditions." },
  { feature: "Range with Booster (LOS)", description: "Portable Booster extends the existing communication network by up to an additional 1–2 KM (LOS)." },
  { feature: "Booster Coverage", description: "Adds up to 1–2 KM of additional line-of-sight coverage to the existing network." },
  { feature: "Performance in Enclosed Spaces", description: "Excellent, up to 10 floors with one booster" },
  { feature: "Audio Clarity in High Noise", description: "High with Throat Mic" },
  { feature: "Full Duplex Natural Conversation", description: "Yes" },
  { feature: "Infrastructure Requirement", description: "None (Booster Optional)" },
  { feature: "Commander Communication", description: "Real-Time with All Team Members" },
  { feature: "IP Rating (Target)", description: "IP65+ (Target). IP-rated models are available from both manufacturers depending on product variant." },
];

export const FEATURES_BENEFITS = [
  { icon: "AudioLines", title: "FULL DUPLEX COMMUNICATION", desc: "Simultaneous talk & listen for natural conversations." },
  { icon: "Hand", title: "HANDS-FREE OPERATION", desc: "Voice activated, 100% hands free for complete focus." },
  { icon: "Feather", title: "ULTRA LIGHTWEIGHT", desc: "All models < 120 grams (including battery)." },
  { icon: "Radio", title: "PORTABLE BOOSTER COMPATIBLE", desc: "Extends range by up to 1–2 KM (LOS) to the existing network." },
  { icon: "ShieldCheck", title: "RUGGED & RELIABLE", desc: "IP65+ protection, built for extreme environments." },
  { icon: "Timer", title: "RAPID DEPLOYMENT", desc: "Pocket sized, mission ready in seconds." },
  { icon: "HardHat", title: "HELMET & UNIFORM MOUNTABLE", desc: "Secure and ergonomic mounting for helmets, uniforms and gear." },
  { icon: "Users", title: "REAL-TIME TEAM CONNECT", desc: "Instant, clear communication with all team members." },
];

// ---- Booster ----
export const BOOSTER_FEATURES = [
  { icon: "Radio", title: "EXTENDED RANGE", desc: "Adds up to 1–2 KM of additional line-of-sight coverage to the existing communication network." },
  { icon: "Network", title: "MULTI BOOSTER RELAY", desc: "Multiple boosters can be deployed in relay mode to provide extended coverage across large facilities, ships, tunnels and multi-storey buildings." },
  { icon: "ShieldCheck", title: "EXCELLENT IN ENCLOSED SPACES", desc: "Advanced RF architecture ensures stable communication in ships, engine rooms, basements, tunnels, factories, high-rise buildings." },
  { icon: "Zap", title: "RAPID DEPLOYMENT", desc: "Pocket sized, mission ready in seconds." },
];

export const BOOSTER_STEPS = [
  { step: 'STEP 1', title: '1 TO 1 (LOS)', sub: 'UP TO 1 – 2 KM*' },
  { step: 'STEP 2', title: 'WITH 1 BOOSTER (LOS)', sub: 'UP TO 1 – 2 KM*' },
  { step: 'STEP 3', title: 'WITH MULTIPLE BOOSTERS (RELAY MODE) (LOS)', sub: 'GREATER COVERAGE' },
];

export const BOOSTER_SPECS = [
  { feature: "1 to 1 (LOS)", spec: "Up to 1 – 2 KM" },
  { feature: "With 1 Booster (LOS)", spec: "Up to 1 – 2 KM additional range" },
  { feature: "With Multiple Boosters (Relay Mode) (LOS)", spec: "Significantly greater coverage" },
  { feature: "Multi Booster Relay", spec: "Seamless coverage across large areas and complex structures" },
  { feature: "Booster Coverage", spec: "Adds up to 1 – 2 KM of additional line-of-sight coverage to the existing communication network." },
  { feature: "Deployment", spec: "Pocket sized, mission ready in seconds." },
];

export const BOOSTER_ENV = [
  "Ships", "Multi-storey Buildings", "Tunnels", "Factories", "Oil & Gas Facilities", "Large Campuses", "Industrial Plants", "Warehouses"
];

// ---- Compare ----
export const COMPARISON = [
  { feature: "Communication Mode", hertz: "Full Duplex (Simultaneous Talk & Listen)", conv: "Push-to-Talk (Half Duplex) Full Duplex models available in select premium series", fact: "HERTZ enables true simultaneous communication.", status: "yes" },
  { feature: "Operation", hertz: "Hands-Free, Voice Activated", conv: "PTT (Push-to-Talk) Voice activation available in some models", fact: "100% hands-free communication for complete mission focus.", status: "yes" },
  { feature: "Key Selling Point", hertz: "Portable • Handheld • Booster Compatible • Ultra-Lightweight • Mission Ready", conv: "Handheld form factor; generally heavier and not designed for helmet or uniform mounting", fact: "HERTZ is purpose-built for portability, mounting and mission readiness.", status: "yes" },
  { feature: "Form Factor / Mounting", hertz: "Helmet & Uniform Mountable", conv: "Conventional Handheld (Configuration dependent)", fact: "HERTZ integrates seamlessly with helmets & uniforms.", status: "yes" },
  { feature: "Weight (Including Battery)", hertz: "All Models < 120 g", conv: "Generally heavier (varies by model)", fact: "Ultra-lightweight for maximum comfort and endurance.", status: "yes" },
  { feature: "Range (Without Booster) (UHF LOS)", hertz: "Comparable or superior UHF line-of-sight performance depending on antenna, terrain and operating conditions.", conv: "Comparable UHF range performance", fact: "Equal or more performance in real-world UHF conditions.", status: "equal" },
  { feature: "Range with Booster (LOS)", hertz: "Portable Booster extends the existing communication network by up to an additional 1–2 KM (LOS).", conv: "Booster / Repeater options available in some professional series", fact: "HERTZ wins with portable booster compatibility.", status: "yes" },
  { feature: "Booster Coverage", hertz: "Adds up to 1–2 KM of additional line-of-sight coverage to the existing communication network. Multiple boosters in relay mode provide greater coverage.", conv: "Depends on infrastructure and model", fact: "Significantly extends range in complex environments.", status: "yes" },
  { feature: "IP Rating", hertz: "IP65+ (Target). IP-rated models are available from both manufacturers depending on product variant.", conv: "IP-rated models are available depending on product variant.", fact: "IP rated options available from both manufacturers.", status: "equal" },
  { feature: "Audio Performance", hertz: "High with Throat Mic, Noise Suppression", conv: "Varies by model", fact: "Optimized for high-noise mission environments.", status: "yes" },
  { feature: "Deployment", hertz: "Seconds – Pocket sized, mission ready", conv: "Relatively slower to deploy", fact: "Fastest deployment when it matters most.", status: "yes" },
  { feature: "Use Case Suitability", hertz: "Fire Fighting, Navy, Defence, Industrial, Mining, Corporate Security, Disaster Response", conv: "General communication use", fact: "Built for mission-critical environments.", status: "yes" },
];

export const WHY_HERTZ = [
  { icon: "AudioLines", title: "FULL DUPLEX COMMUNICATION", desc: "Simultaneous talk and listen for natural conversations and efficient teamwork." },
  { icon: "Hand", title: "HANDS-FREE OPERATION", desc: "100% hands free communication allows complete focus on mission critical tasks." },
  { icon: "Radio", title: "PORTABLE BOOSTER COMPATIBLE", desc: "Extends the existing communication network by up to 1–2 KM (LOS) with the portable booster." },
  { icon: "Feather", title: "ULTRA LIGHTWEIGHT", desc: "All models < 120 grams (including battery) for maximum comfort and mobility." },
  { icon: "HardHat", title: "HELMET & UNIFORM MOUNTABLE", desc: "Secure and ergonomic mounting for helmets, uniforms and gear." },
  { icon: "ShieldCheck", title: "RUGGED & RELIABLE", desc: "IP65+ protection, built for extreme environments." },
  { icon: "Timer", title: "INSTANT DEPLOYMENT", desc: "Pocket sized, mission ready in seconds." },
  { icon: "Users", title: "REAL-TIME TEAM CONNECT", desc: "Instant, clear communication with all team members." },
  { icon: "Layers", title: "ONE SYSTEM. MULTIPLE MISSIONS.", desc: "HERTZ adapts to any scenario, delivering seamless, reliable communication when it matters most." },
];

export const QUALITY_ASSURANCE = [
  "Rugged Design & Durability Testing",
  "Environmental Testing (Temperature, Humidity, Vibration)",
  "Drop & Impact Resistance Testing",
  "Stringent Quality Control at Every Stage",
];

export const RUGGED_BADGES = [
  { icon: "ShieldCheck", title: "IP65+ PROTECTION", sub: "BUILT FOR HARSH ENVIRONMENTS" },
  { icon: "Thermometer", title: "OPERATING TEMP.", sub: "-20°C TO +60°C" },
  { icon: "Network", title: "RELIABLE CONNECTIVITY", sub: "WHEN IT MATTERS MOST" },
];

// ---- Modules ----
export const MODULES = [
  {
    letter: "A",
    title: "COMMANDER MODULE",
    sub: "Tactical Command Hub",
    img: '/mod_commander.png',
    specs: [
      { icon: "Weight", label: "Weight", value: "< 120 g" },
      { icon: "Ruler", label: "Dimensions (Approx.)", value: "75 × 50 × 22 mm" },
      { icon: "AudioLines", label: "Frequency Band", value: "UHF/VHF" },
      { icon: "Volume2", label: "Audio", value: "High Quality Speaker & Microphone" },
      { icon: "Hand", label: "Mounting", value: "Handheld / Helmet / Uniform Mountable" },
      { icon: "Usb", label: "Charging", value: "Type-C Fast Charging" },
    ],
    tags: ["FULL DUPLEX", "HANDS-FREE", "VOICE ACTIVATED", "COMMANDER PRIORITY", "TYPE C CHARGING"],
  },
  {
    letter: "B",
    title: "PORTABLE BOOSTER",
    sub: "Range Extension. Mission Multiplier.",
    img: '/mod_booster.png',
    specs: [
      { icon: "Weight", label: "Weight", value: "< 120 g" },
      { icon: "Ruler", label: "Dimensions (Approx.)", value: "75 × 50 × 18 mm" },
      { icon: "Radio", label: "Coverage", value: "Adds up to 1–2 KM (LOS) to existing network" },
      { icon: "Network", label: "Relay Mode", value: "Yes, Multiple Boosters (Relay Mode)" },
      { icon: "Hand", label: "Mounting", value: "Pocket Carry / Belt Mount" },
      { icon: "Usb", label: "Charging", value: "Type-C Fast Charging" },
    ],
    tags: ["POCKET SIZED", "PLUG & DEPLOY", "EXTENDED RANGE", "MULTI BOOSTER RELAY", "TYPE C CHARGING"],
  },
  {
    letter: "C",
    title: "HELMET UNIT",
    sub: "Lightweight. Hands-Free. Mission Ready.",
    img: '/mod_helmet.png',
    specs: [
      { icon: "Weight", label: "Weight", value: "< 130 g" },
      { icon: "Ruler", label: "Dimensions (Approx.)", value: "75 × 50 × 18 mm" },
      { icon: "AudioLines", label: "Frequency Band", value: "UHF/VHF" },
      { icon: "Volume2", label: "Audio", value: "Throat Mic Compatible High Quality Audio" },
      { icon: "HardHat", label: "Mounting", value: "Helmet & Uniform Mountable" },
      { icon: "Usb", label: "Charging", value: "Type-C Fast Charging" },
    ],
    tags: ["HELMET MOUNTABLE", "UNIFORM MOUNTABLE", "THROAT MIC COMPATIBLE", "LIGHTWEIGHT DESIGN", "FULL DUPLEX"],
  },
];

export const APPLICATIONS = [
  { label: "FIRE\nFIGHTING", img: '/fire_safety.jpeg' },
  { label: "DEFENCE", img: '/defense.jpeg' },
  { label: "NAVY &\nCOAST GUARD", img: '/navy.jpeg' },
  { label: "INDUSTRIAL\nSAFETY", img: '/industrial_safety.jpeg' },
  { label: "CORPORATE\nSECURITY", img: '/corporate.jpeg' },
  { label: "DISASTER\nRESPONSE", img: '/disaster.jpeg' },
  { label: "OIL & GAS", img: '/oil.jpeg' },
  { label: "NAVY &\nMARITIME", img: '/navy_war.jpeg' },
];
